export const environment: any = {
  production: true,
  apiURL: 'https://api.cimalti.com'
};
